import React, { useState } from 'react';
import { Box, Typography, Divider, Button, Snackbar, Alert, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import phaseService from '../../../../services/PhaseService';

import LaunchReadinessPanel from './LaunchReadinessPanel';
import SubscriptionManagementPanel from './SubscriptionManagementPanel';
import ApplicantManagementPanel from './ApplicantManagementPanel';


interface LaunchPanelProps {
  campaignId: string;
  organizationId: string;
  isLaunched: boolean;
}

const LaunchPanel: React.FC<LaunchPanelProps> = ({
  campaignId,
  organizationId,
  isLaunched = false
}) => {
  const [readyToLaunch, setReadyToLaunch] = useState(false);
  const [launching, setLaunching] = useState(false);
  const [snackbar, setSnackbar] = useState<{open:boolean;message:string;severity:'success'|'error'}>({open:false,message:'',severity:'success'});
  const navigate = useNavigate();

  const handleLaunch = async () => {
    setLaunching(true);
    try {
      await phaseService.launchCampaign(organizationId, campaignId);
      setSnackbar({open:true,message:'Campaign launched successfully!',severity:'success'});
      // Optionally navigate to overview or refresh
      navigate(0);
    } catch (e:any) {
      console.error('Launch failed', e);
      setSnackbar({open:true,message:'Unable to launch campaign. Please try again.',severity:'error'});
    } finally {
      setLaunching(false);
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Launch Panel
      </Typography>

      <LaunchReadinessPanel
        organizationId={organizationId}
        campaignId={campaignId}
        onReadinessChange={setReadyToLaunch}
      />

      {readyToLaunch && !isLaunched && (
        <Box sx={{ my: 2, textAlign:'center' }}>
          <Button variant="contained" color="primary" disabled={launching} onClick={handleLaunch} startIcon={launching ? <CircularProgress size={20} /> : undefined}>
            {launching ? 'Launching...' : 'Launch Campaign'}
          </Button>
        </Box>
      )}

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({...snackbar,open:false})}>
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({...snackbar,open:false})}>{snackbar.message}</Alert>
      </Snackbar>
      
      <Divider sx={{ my: 3 }} />
      
      <ApplicantManagementPanel 
        campaignId={campaignId}
        organizationId={organizationId}
      />
      
      <Divider sx={{ my: 3 }} />
      
      <SubscriptionManagementPanel
        organizationId={organizationId}
      />
    </Box>
  );
};

export default LaunchPanel;